import AppSearchListItem from '../app-search-list-item'
import AppMagma from '../app-magma'

export default
{
    components:
    {
        AppMagma,
        AppSearchListItem
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            searchValue: '',

            hasBtnMore: false,
            isTagsExpended: false,

            offsetBtnMoreLeft: 0,

            response: null,
            categories: null

        }
    },

    created()
    {
        this._tag = {
            height: 42,
            marginBottom: 10
        }

        this._tagsList = {
            height: 0
        }

        this._query = ''
        this._tags = []

        this.eventHub.$on('window:resize', this.onResize)

        this.categories = this.content.categories.sort(function(a, b)
        {
            return b.count < a.count;
        }).reverse()
    },

    mounted()
    {
        this.$tags = this.$el.querySelector('.js-tags')
        this.$tagsList = this.$el.querySelector('.js-tags-list')

        this.$tag = this.$el.querySelectorAll('.js-tag')


        if(this.getURLParameter('tag'))
        {
            const param = this.getURLParameter('tag')
            this._tags.push(param)

            for(let i = 0; i < this.categories.length; i++)
            {
                if(this.categories[i].slug === param)
                {
                    this.$tag[i].children[0].classList.add('is-active')
                }
            }

            this.fetch()
        }
        else
        {
           this.$el.querySelector('.js-input').focus()
        }


        setTimeout(() =>
        {
            this.onResize()

            this.$nextTick(() =>
            {
                this.$emit('page:ready')
            })
        }, 50)
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onResize()
        {
            if(!this.$tag[0])
            {
                return
            }

            this._tag.height = this.$tag[0].offsetHeight

            this._tagsList.height = this.$tagsList.offsetHeight

            // add btn more if tags are displayed on more than 2 lines
            if(this._tagsList.height > (this._tag.height + this._tag.marginBottom) * 2 )
            {
                this.hasBtnMore = true
                this.$tags.style.height = this._tag.height * 2 + this._tag.marginBottom  + 'px'
            }
            else
            {
                this.hasBtnMore = false

                this.$tags.style.height = this._tagsList.height + 'px'
            }

            for(let i = 0; i < this.$tag.length; i++)
            {
                this.$tag[i].style.transform = 'translateX(' + 0 + 'px) translateZ(0)'

                if(this.hasBtnMore && this.$tag[i].offsetTop <= this._tag.height * 2)
                {
                    this.offsetBtnMoreLeft = this.$tag[i].offsetLeft + this.$tag[i].offsetWidth + 8 - 21
                }

                if(this.hasBtnMore && this.$tag[i].offsetTop <= this._tag.height * 2 && this.$tag[i].offsetTop > 0)
                {
                    this.$tag[i].style.transform = 'translateX(' + -21 + 'px) translateZ(0)'
                }
            }
        },

        onSearch(event)
        {
            clearTimeout(this._fetchTimer)
            this._query = event.target.value

            if(this._query.length > 0)
            {
                this._fetchTimer = setTimeout(() =>
                {
                    this.$el.classList.remove('is-list-active')
                    this.fetch()
                }, 300)
            }
            else
            {
                this.$el.classList.remove('is-list-active')
                this.response = null
                // this.fetch()

                console.log('laa')
            }
        },

        onMouseEnter()
        {
            this._isResultsOver = true
        },

        onMouseLeave()
        {
            this._isResultsOver = false
        },

        onInputFocus()
        {
            this.$el.classList.add('is-list-active')
        },

        onInputBlur()
        {
            if(!this._isResultsOver)
            {
                this.$el.classList.remove('is-list-active')
            }
        },

        onToggleTags()
        {
            this.isTagsExpended = !this.isTagsExpended
            this.$el.classList.toggle('is-expanded')

            if(this.isTagsExpended)
            {
                this.$tags.style.height = this._tagsList.height - this._tag.marginBottom + 'px'

                for(let i = 0; i < this.$tag.length; i++)
                {
                    if(this.hasBtnMore && this.$tag[i].offsetTop <= this._tag.height * 2 && this.$tag[i].offsetTop > 0)
                    {
                        this.$tag[i].style.transform = 'translateX(' + 0 + 'px) translateZ(0)'
                    }
                }
            }
            else
            {
                this.$tags.style.height = this._tag.height * 2 + this._tag.marginBottom  + 'px'

                for(let i = 0; i < this.$tag.length; i++)
                {
                    if(this.hasBtnMore && this.$tag[i].offsetTop <= this._tag.height * 2 && this.$tag[i].offsetTop > 0)
                    {
                        this.$tag[i].style.transform = 'translateX(' + -21 + 'px) translateZ(0)'
                    }
                }
            }
        },

        onToggleCat(event, slug)
        {
            const el = event.currentTarget

            if(this._tags.includes(slug))
            {
                el.classList.remove('is-active')
                const index = this._tags.indexOf(slug)
                this._tags.splice(index, 1)
            }
            else
            {
                el.classList.add('is-active')
                this._tags.push(slug)
            }

            this.fetch()
        },

        fetch()
        {
            const headers = new Headers()

            headers.set('Authorization', 'Basic ' + btoa('edouardfrancois' + ':' + '3vRrNLnSl47r'))

            fetch(this.$root.baseApiUrl + this.$root.lang + '/search?query=' + this._query + '&tags=' +  encodeURIComponent(JSON.stringify(this._tags)) + '&lang=' + this.$root.lang, {
                headers
            })
            .then(this.handleErrors)
            .then((response) =>
            {
                const contentType = response.headers.get('content-type')

                if(contentType && contentType.indexOf('application/json') !== -1 )
                {
                    response.json().then((json) =>
                    {
                        this.$el.classList.remove('is-results-overflow')
                        this.response = null

                        this.$nextTick(() =>
                        {
                            this.response = json

                            if(this._query.length > 0)
                            {
                                this.$el.classList.add('is-list-active')
                            }

                            this.$nextTick(() =>
                            {
                                if(this.response.search.results)
                                {
                                   if(this.$el.querySelector('.js-results').offsetHeight > (this.$root.window.height / 100) * 40)
                                   {
                                        this.$el.classList.add('is-results-overflow')
                                   }
                                   else
                                   {
                                        this.$el.classList.remove('is-results-overflow')
                                   }
                                }
                            })
                        })
                    })
                }
            })
            .catch((error) =>
            {
                console.warn('error when fetching ' + this.src + ':\n' + error)
                this.$emit('data:error')
            })
        },

        getURLParameter(name)
        {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-search/script.js